// components/SelectBusinessAddressDialog.jsx
import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
} from '@mui/material';
import ConfirmPopup from '../common/ConfirmPopup';
import { postAsync } from '../../core/serviceClient';

const SelectBusinessAddressDialog = ({
    open,
    onClose,
    pass,
    onDefaultCLick,
    addressList = [],
    onSelectAddress,
}) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmText, setConfirmText] = useState('');
    const [defaultAddress, setDefaultAddress] = useState(null);

    useEffect(() => {
        if (open) {
            loadDefaultAddress();
        }
    }, [open]);

    const loadDefaultAddress = async () => {
        const request = { Id: pass.customerId, BusinessId: pass.customerId };
        const result = await postAsync('Customer/GetCustomer', request, '', 'Get');
        if (!result.error) {
            const tmpy = {
                customerBillingName: pass.userName,
                customerBillingMobileNumber: pass.mobileNumber,
                customerBillingAddress: result.data.homeLocation,
                customerBillingGSTNumber: result.data.registrationId,
            };
            setDefaultAddress(tmpy);
        }
    };

    const handleSelectClick = (type, value, index = null) => {
        if (type === "default") {
            onSelectAddress(value);   // defaultAddress
            onClose();
        } else if (type === "selected" && value) {
            setSelectedIndex(index);
            onSelectAddress(value);   // from addressList
            onClose();
        } else {
            setConfirmText('Please select a business detail');
            setConfirmOpen(true);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} className="cs-modal-sec" fullWidth>
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pb: 0,
                }}
            >
                <Typography component="h1" className='font-size-14' fontWeight={600} fontSize="1.6rem">
                    Select the billing details
                </Typography>
            </DialogTitle>

            <DialogContent dividers className='font-size-12'>
                <Stack spacing={2}>
                    {defaultAddress && (
                        <div
                            onClick={() => onDefaultCLick(true)}
                            // onClick={() => handleSelectClick('default', defaultAddress)}
                            style={{
                                border: '2px dashed #4caf50',
                                backgroundColor: '#f0fff4',
                                borderRadius: '8px',
                                padding: '12px',
                                cursor: 'pointer',
                            }}
                        >
                            <Stack direction="row" justifyContent="space-between">
                                <Typography fontWeight={600}>Default Address</Typography>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        backgroundColor: '#4caf50',
                                        color: 'white',
                                        px: 1,
                                        borderRadius: '4px',
                                    }}
                                >
                                    Default
                                </Typography>
                            </Stack>
                            <Typography><strong>Customer Name:</strong> {defaultAddress.customerBillingName}</Typography>
                            <Typography><strong>Address:</strong> {defaultAddress.customerBillingAddress}</Typography>
                            <Typography><strong>GST Number:</strong> {defaultAddress.customerBillingGSTNumber}</Typography>
                            <Typography><strong>Mobile:</strong> {defaultAddress.customerBillingMobileNumber}</Typography>
                        </div>
                    )}

                    {/* 📋 Other Saved Addresses */}
                    {addressList.length === 0 ? (
                        <Typography color="textSecondary">No billing details available.</Typography>
                    ) : (
                        addressList.map((detail, index) => (
                            <div
                                key={index}
                                onClick={() => handleSelectClick('selected', detail, index)}
                                style={{
                                    border: selectedIndex === index
                                        ? '2px solid #1976d2'
                                        : '1px solid #ccc',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                }}
                            >
                                <Typography><strong>Customer Name:</strong> {detail.customerBillingName}</Typography>
                                <Typography><strong>Address:</strong> {detail.customerBillingAddress}</Typography>
                                <Typography><strong>GST Number:</strong> {detail.customerBillingGSTNumber}</Typography>
                                <Typography><strong>Mobile:</strong> {detail.customerBillingMobileNumber}</Typography>
                            </div>
                        ))
                    )}
                </Stack>
            </DialogContent>

            <DialogActions>
                <Button
                    variant="contained"
                    onClick={onClose}
                    className="btn btn-secondary"
                    sx={{ backgroundColor: 'gray' }}
                >
                    Close
                </Button>
            </DialogActions>

            <ConfirmPopup
                confirmOpen={confirmOpen}
                confirmText={confirmText}
                onConfirmClose={() => setConfirmOpen(false)}
            />
        </Dialog>
    );
};

export default SelectBusinessAddressDialog;
